import type { SubFrequencyKey } from '@c214/shared';
import {
  formatMoney,
  SUB_FREE_SHIPPING_MIN_QTY,
  SUB_FREQUENCIES,
  SUB_SHIPPING_COST,
  subscriptionTotal,
} from '@c214/shared';
import { Button } from '../ui/button';

export function SubscriptionSummary({
  label,
  unitPrice,
  qty,
  frequency,
  onSubmit,
  isSubmitting,
  submitLabel,
  errorMessage,
}: {
  label: string;
  unitPrice: number;
  qty: number;
  frequency: SubFrequencyKey;
  onSubmit: () => void;
  isSubmitting: boolean;
  submitLabel: string;
  errorMessage?: string;
}) {
  const freqEntry = SUB_FREQUENCIES.find((f) => f.key === frequency);
  const base = unitPrice * qty;
  const discount = freqEntry ? Math.round(base * freqEntry.discount) : 0;
  const shipping = qty >= SUB_FREE_SHIPPING_MIN_QTY ? 0 : SUB_SHIPPING_COST;
  const total = subscriptionTotal(unitPrice, qty, frequency);
  const periodWord =
    frequency === 'weekly'
      ? 'щотижня'
      : frequency === 'monthly'
        ? 'раз на місяць'
        : 'раз на 2 тижні';

  return (
    <aside className="self-start border border-line bg-surface p-6">
      <div className="flex justify-between text-[14px] text-ink">
        <span>
          {label} × {qty}
        </span>
        <span>{formatMoney(base)}</span>
      </div>
      <div className="mt-2 flex justify-between text-[14px] text-accent">
        <span>Знижка підписника</span>
        <span>−{formatMoney(discount)}</span>
      </div>
      <div className="mt-2 flex justify-between text-[14px] text-muted">
        <span>Доставка</span>
        <span>{formatMoney(shipping)}</span>
      </div>
      <div className="mt-4 flex justify-between border-t border-line pt-4">
        <span className="mono-label">Списання {periodWord}</span>
        <span className="text-[32px] font-extrabold text-ink">{formatMoney(total)}</span>
      </div>
      <Button
        variant="accent"
        size="lg"
        className="mt-6 w-full"
        onClick={onSubmit}
        disabled={isSubmitting}
      >
        {submitLabel}
      </Button>
      {errorMessage && <p className="mt-3 text-[13px] text-warn">{errorMessage}</p>}
      <p className="mono-label mt-4">НАГАДАЄМО ЗА 2 ДНІ ДО СПИСАННЯ</p>
    </aside>
  );
}
